import ApiBase from '../ApiBase';

class Agenda extends ApiBase {
    route = '/admin/agenda';
}

export default new Agenda();